export function registerNativeAppKeyboardCallback(cb: (status: 'willShow' | 'didShow' | 'willHide') => void) {
  window.nativeCallbackKeyboardStatus = cb;
}
